export enum CubeMenu {
  Company = "CubeMenu:Company:VIEW",
  OldPatient = "CubeMenu:OldPatient:View",
  Billing = "CubeMenu:Billing:VIEW",
  LegacyBilling = "CubeMenu:LegacyBilling:VIEW",
  Patient = "CubeMenu:Patients:VIEW",
  Reports = "CubeMenu:Reports:VIEW",
  HIS = "CubeMenu:HISExport:VIEW",
  Workforce = "Company:Workforce:VIEW",
  Compliance = "CubeMenu:Compliance:VIEW",
  ResourceManagement = "CubeMenu:ResourceManagement:VIEW",
  Analytics = "CubeMenu:Analytics:VIEW",
  CommunityBereavement = "CubeMenu:CommunityBereavement:VIEW",
  OrderManagement = "CubeMenu:OrderManagement:VIEW",
  Eprescribe = "CubeMenu:Eprescribe:VIEW",
  Facilities = "CubeMenu:Facilities:VIEW",
  Provider = "CubeMenu:Provider:VIEW",
  LegacyApp = "CubeMenu:LegacyApp:VIEW",
  ReferralAndIntake = "CubeMenu:Patients:VIEW",
  ChartMeds = "CubeMenu:Chartmeds:VIEW",
}

export enum Pages {
  Visit = "Patients:PatientChart:CarePlan:VIEW",
  PlanOfCare = "Patients:PatientChart:BriefBar:PlanOfCare:VIEW",
  AssessmentSection = "Patients:PatientChart:CarePlan:Assessment:VIEW",
  PatientPage = "Patients:PatientChart:Profile:PatientDetails:VIEW",
  IDGPage = "IDGMeetings:Meeting:VIEW",
  PatientChartPage = "Patients:PatientChart:VIEW",
  VolunteerManagementPage = "Company:Workforce:Volunteers:VIEW",
  ResourceManagement = "UI:Page:ResourceManagement",
  CTIPage = "Patients:PatientChart:Certifications:Verbal:VIEW",
  OrderManagementPage = "OrderManagement:Orders:VIEW",
  BillingSection = "UI:Page:BillingSection",
  CalendarPage = "Calendar:Visits:ADD",
  PatientPatientChartProfileTab = "Patients:PatientChart:Profile:VIEW",
  PatientAddPatientAdmitPatient = "Patients:PatientChart:AdmitPatient:VIEW",
}

export enum VolunteerManagement {
  VMPAdministrator = "VolunteerActivity:*",
  VMPVolunteer = "VolunteerActivity:VIEW",
  VMPVolunteerAdd = "VolunteerActivity:ADD",
  VMPVolunteerEdit = "VolunteerActivity:EDIT",
}

export enum CTI {
  CertVerbal = "Patients:PatientChart:Certifications:Verbal:VIEW",
  CertWritten = "Patients:PatientChart:Certifications:Written:VIEW",
  CertWrittenAdd = "Patients:PatientChart:Certifications:Written:ADD",
  CertVerbalAdd = "Patients:PatientChart:Certifications:Verbal:ADD",
  CertWrittenEdit = "Patients:PatientChart:Certifications:Written:EDIT",
  CertVerbalEdit = "Patients:PatientChart:Certifications:Verbal:EDIT",
}

export enum Consents {
  ConsentsEdit = "Patients:PatientChart:Consents:EDIT",
  ConsentTabAddPatient = "Patients:PatientChart:Consents:EDIT",
}

export enum Diagnosis {
  DiagnosisView = "Patients:PatientChart:Profile:Diagnosis:VIEW",
  DiagnosisEdit = "Patients:PatientChart:Profile:Diagnosis:EDIT",
  DiagnosisAdd = "Patients:PatientChart:Profile:Diagnosis:ADD",
  DiagnosisHistoryView = "Patients:PatientChart:Profile:Diagnosis:History:VIEW",
}

export enum PatientChart {
  BereavementView = "Patients:PatientChart:Bereavement:VIEW",
}

export enum Bereavement {
  BereavementView = "Dashboard:Bereavement:VIEW",
}

export enum PatientSchedule {
  View = "Patients:PatientChart:Schedule:VIEW",
}

export enum CalendarVisits {
  DeleteVfoLinkedVisit = "Calendar:Visits:VFO:DELETE",
}

export enum PatientProfile {
  ActivityEdit = "Patients:PatientChart:Activity:EDIT",
  ActivityView = "Patients:PatientChart:Activity:VIEW",
  AllergyView = "Patients:PatientChart:Allergies:VIEW",
  BereavementView = "Patients:PatientChart:Bereavement:VIEW",
  CareTeamEdit = "Patients:PatientChart:CareTeam:EDIT",
  CareTeamView = "Patients:PatientChart:CareTeam:VIEW",
  ClaimsView = "Patients:PatientChart:Claims:VIEW",
  ConsentView = "Patients:PatientChart:Consents:VIEW",
  DMEEdit = "Patients:PatientChart:MedsDME:EDIT",
  DocumentEdit = "Patients:PatientChart:Documents:EDIT",
  DocumentView = "Patients:PatientChart:Documents:VIEW",
  DocumentDelete = "Patients:PatientChart:Documents:DELETE",
  HISView = "Patients:PatientChart:HIS:VIEW",
  LevelOfCareEdit = "Patients:PatientChart:Profile:LevelOfCare:EDIT",
  LevelOfCareView = "Patients:PatientChart:Profile:LevelOfCare:VIEW",
  MedicationView = "Patients:PatientChart:Medications:VIEW",
  NoteView = "Patients:PatientChart:Notes:VIEW",
  PhysiciansEdit = "Patients:PatientChart:Profile:PatientDetails:ReferringPhysician:EDIT",
  ReportsView = "Patients:PatientChart:Reports:VIEW",
  Status = "Patients:PatientChart:Profile:Status:VIEW",
  StatusChange = "Patients:PatientChart:Profile:Status:EDIT",
  StatusHistoryTab = "Patients:PatientChart:Profile:StatusHistory:*",
  View = "Patients:PatientChart:Profile:PatientDetails:VIEW",
  EPrescribeView = "Patients:PatientChart:ePrescribe:VIEW",
  AddPatientDetailsEdit = "Patients:PatientChart:Profile:PatientDetails:EDIT",
  AddPatientEdit = "Patients:AddPatient:EDIT",
  CallerReferrerAdd = "Patients:PatientChart:Profile:PatientDetails:CallerReferrer:ADD",
  CallerReferrerEdit = "Patients:PatientChart:Profile:PatientDetails:CallerReferrer:EDIT",
  ReferringPhysicianAdd = "Patients:PatientChart:Profile:PatientDetails:ReferringPhysician:ADD",
  ReferringPhysicianEdit = "Patients:PatientChart:Profile:PatientDetails:ReferringPhysician:EDIT",
  OrderingPhysicianAdd = "Patients:PatientChart:Profile:PatientDetails:OrderingPhysician:ADD",
  OrderingPhysicianEdit = "Patients:PatientChart:Profile:PatientDetails:OrderingPhysician:EDIT",
  // New permissions for Pharmacy, Funeral Home, Referring Physician, and Ordering Physician
  PharmacyAdd = "Patients:PatientChart:Profile:PatientDetails:Pharmacy:ADD",
  PharmacyEdit = "Patients:PatientChart:Profile:PatientDetails:Pharmacy:EDIT",
  PharmacyVAView = "Patients:PatientChart:Profile:PatientDetails:PharmacyVA:VIEW",
  PharmacyView = "Patients:PatientChart:Profile:PatientDetails:Pharmacy:VIEW",
  FuneralHomeAdd = "Patients:PatientChart:Profile:PatientDetails:FuneralHome:ADD",
  FuneralHomeEdit = "Patients:PatientChart:Profile:PatientDetails:FuneralHome:EDIT",
  FuneralHomeVAView = "Patients:PatientChart:Profile:PatientDetails:FuneralHomeVA:VIEW",
  FuneralHomeView = "Patients:PatientChart:Profile:PatientDetails:FuneralHome:VIEW",
  ReferringPhysicianVAView = "Patients:PatientChart:Profile:PatientDetails:ReferringPhysicianVA:VIEW",
  ReferringPhysicianView = "Patients:PatientChart:Profile:PatientDetails:ReferringPhysician:VIEW",
  OrderingPhysicianVAView = "Patients:PatientChart:Profile:PatientDetails:OrderingPhysicianVA:VIEW",
  OrderingPhysicianView = "Patients:PatientChart:Profile:PatientDetails:OrderingPhysician:VIEW",
}

export enum CarePlanVisit {
  FrequencyButtonAdd = "Patients:PatientChart:CarePlan:VisitFrequency:ADD",
  FrequencyButtonEdit = "Patients:PatientChart:CarePlan:VisitFrequency:EDIT",
  FrequencyButtonDelete = "Patients:PatientChart:CarePlan:VisitFrequency:DELETE",
  CarePlanTabVisitsAdd = "Patients:PatientChart:CarePlan:Visit:ADD",
  CarePlanTabVisitButtonEdit = "Patients:PatientChart:CarePlan:Visit:EDIT",
}

export enum OrderManagement {
  PatientOrderManagementEdit = "Patients:PatientChart:OrderManagement:OrderEntry:EDIT",
}

export enum PatientChartBenefits {
  PatientChartBenefitsView = "Patients:PatientChart:Benefits:VIEW",
  PatientChartBenefitsAdd = "Patients:PatientChart:Benefits:ADD",
  PatientChartBenefitsEdit = "Patients:PatientChart:Benefits:EDIT",
}

export enum ReferralPatientChartBenefits {
  ReferralPatientChartBenefitsView = "Patients:ReferralPatientChart:Benefits:VIEW",
  ReferralPatientChartBenefitsAdd = "Patients:ReferralPatientChart:Benefits:ADD",
  ReferralPatientChartBenefitsEdit = "Patients:ReferralPatientChart:Benefits:EDIT",
}

export enum Teams {
  TeamsAll = "Company:Locations:Teams:*",
  TeamsView = "Company:Locations:Teams:VIEW",
  TeamsAdd = "Company:Locations:Teams:ADD",
  TeamsEdit = "Company:Locations:Teams:EDIT",
  TeamsDelete = "Company:Locations:Teams:DELETE",
}

export enum ActivityLog {
  ActivityLogAll = "Company:Locations:ActivityLog:*",
  ActivityLogView = "Company:Locations:ActivityLog:VIEW",
  ActivityLogAdd = "Company:Locations:ActivityLog:ADD",
  ActivityLogEdit = "Company:Locations:ActivityLog:EDIT",
  ActivityLogDelete = "Company:Locations:ActivityLog:DELETE",
}

export enum Facilites {
  FacilitesView = "Company:Locations:Facilites:VIEW",
}

export enum Workforce {
  CompanyWorkforceView = "Company:Workforce:VIEW",
  CompanyWorkforceEdit = "Company:Workforce:EDIT",
  CompanyWorkforceAdd = "Company:Workforce:ADD",
  CompanyWorkforceAll = "Company:Workforce:*",
}

/**
 * OPS-2873 - the company-level Multi-Site Team tab in Company -> Work Force.
 *
 * The tab LABEL is "Multi-Site Team"; the permission segment is deliberately "MultiSiteTeam" with
 * no space or hyphen. See the CO-3551 warning below on Company:QAControls:Visit Type:EDIT - IAM
 * matches these strings verbatim, so a segment anyone might "tidy" is a permanent footgun.
 *
 * There is no DELETE: exactly one Multi-Site Team is ever created per company, and it is renameable
 * rather than replaceable. Removing a MEMBER is covered by EDIT.
 */
export enum MultiSiteTeam {
  MultiSiteTeamAll = "Company:Workforce:MultiSiteTeam:*",
  MultiSiteTeamView = "Company:Workforce:MultiSiteTeam:VIEW",
  MultiSiteTeamAdd = "Company:Workforce:MultiSiteTeam:ADD",
  MultiSiteTeamEdit = "Company:Workforce:MultiSiteTeam:EDIT",
}

export enum Locations {
  CompanyLocationsView = "Company:Locations:VIEW",
  CompanyLocationsAll = "Company:Locations:*",
}

export enum QaQueue {
  DashboardView = "Dashboard:QA:VIEW",
  DashboardEdit = "Dashboard:QA:EDIT",
  CompanyControlsView = "Company:QAControls:VIEW",
  // CO-3551: the space in "Visit Type" is REQUIRED and must not be "tidied" away.
  // Permission names are built by the roles-permissions importer by joining the
  // master-file columns verbatim with ":" (sys-admin-utilities
  // lib/models/roles-permissions/permission.go GetPermissionName), and the
  // catalogue's section column for this row is "Visit Type". IAM matches on an
  // exact string, so "VisitType" resolves to access:false and silently makes the
  // whole Visit Type grid read-only.
  CompanyControlsEditVisitType = "Company:QAControls:Visit Type:EDIT",
  CompanyControlsEditUsers = "Company:QAControls:Users:EDIT",
}

// QualityBoost (CO-2199) is a separate product built on top of the EHR, not the
// existing QA queue. Its surfaces are gated by their own permission so the
// role-to-view matrix (REQ-UI-010) can grant QA Reviewer / QA Director / DON /
// Executive / Compliance while the Surveyor role is NEVER granted it
// (REQ-UI-009). The exclusion is enforced server-side in the IAM permission
// catalogue (REQ-UI-007) — this UI only hides the entry when access is false.
export enum QualityBoost {
  QueueView = "Dashboard:QualityBoost:VIEW",
}

export enum ProviderPanel {
  DashboardView = "Dashboard:ProviderPanel:VIEW",
  DashboardSupportView = "Dashboard:ProviderPanel:Support:VIEW",
}

// CO-2315 Round-2 item #6 / F2.S14 — the elevated Agency Admin payer-classification
// permission. Mirrors the constant enforced server-side in payer-functions
// (services.ClassificationPermission); the two must not drift, because a mismatch would
// leave the form editable while every save is refused with a 403.
//
// This is a CURANTIS iam permission (a row in the RolesPermissions catalog, evaluated by
// POST /iam) - NOT AWS IAM.
export enum PayerClassification {
  Edit = "Company:Payers:Classification:EDIT",
}

// CO-2315 item #5 / PRD 1 REQ-012a - who may maintain the Medi-Cal Aid Code reference
// table, and (D-4) who may read its change history.
//
// THE MODULE SEGMENT IS A COMPROMISE AND IS RECORDED AS ONE. "Company" names the
// customer's own configuration area, and this table is not the customer's - Curantis
// maintains it centrally for every agency. No Module value means "Curantis staff", so
// every option was a compromise; this one fits the shape HasAccess already matches, with
// "Reference" as a new Area. The "this is ours" signal lives in the ROLE name instead -
// `Curantis - AID Code Administrator` - which is what an administrator reads when
// granting it. Ruled 2026-09-04 (Will Bunker), reversible.
//
// The string is a contract across three files that cannot see each other:
//   1. here
//   2. services.AidCodeEditPermission, patient-benefits-functions
//   3. domains/platform/libraries/user-permissions/scripts/data/Permissions.json
// A mismatch does not 500. It refuses everyone, silently - which is exactly what item #6
// shipped when its catalog row was never seeded.
//
// This is a CURANTIS iam permission (a row in the RolesPermissions catalog, evaluated by
// POST /iam) - NOT AWS IAM.
export enum AidCodes {
  Edit = "Company:Reference:AidCodes:EDIT",
}

// CO-2315 item #8 / F10.S11 - the claim-error override privilege.
//
// The spec calls it "the claim-error override privilege defined by the claim validation
// catalog", and the on-screen affordance names it "billing-admin".
//
// This is a CURANTIS iam permission (a row in the RolesPermissions catalog, evaluated by
// POST /iam) - NOT AWS IAM.
//
// THE STRING IS A CONTRACT WITH THE API and is stated in exactly two places: here, and
// ClaimErrorOverridePermission in
// domains/billing/functions/claim-functions/src/lib/services/claim_error_override_permission.go.
// If the two drift, this page disables a button nobody is actually refused, or opens one
// everybody is - and neither shows up as an error anywhere. Both sides pin the literal in a
// test for that reason.
//
// It is NOT the same axis as the showOverridesClaimErrors feature toggle. The toggle says
// whether the capability exists for this tenant; this says whether this person may use it.
export enum ClaimErrorOverride {
  Edit = "Billing:Claims:ErrorOverride:EDIT",
}

// CO-3390 Feature 8 — the accounts-receivable adjustment permissions.
//
// This is a CURANTIS iam permission (a row in the RolesPermissions catalog, evaluated by
// POST /iam) - NOT AWS IAM.
//
// THE STRINGS ARE A CONTRACT WITH THE API and are stated in exactly two places: here, and
// as constants in domains/billing/libraries/iam-permissions/billing_permissions.go, which
// accounts-receivable-functions enforces. Both sides pin the literals in a test - if they
// drift, this page hides a control nobody is refused, or offers one everybody is, and
// neither shows up as an error anywhere.
//
// Add and Delete are DELIBERATELY separate grants: BDD F8.S8 casts a user who may apply an
// adjustment but may not reverse one, which is unreachable if one permission covers both.
// The same is true of the approval queue's View and Edit - PRD-04-WO F3.S5 is a read-only
// queue, which only exists if seeing it and acting on it are different grants.
//
// The verbs are the platform's, not ours. The live catalog's action vocabulary is closed -
// VIEW, EDIT, ADD, DELETE, * - so voiding is DELETE and approving is EDIT on the approval
// itself. There is no VOID or APPROVE verb and inventing one would make ours the first.
export enum AccountsReceivableAdjustment {
  View = "Billing:AccountsReceivable:Adjustment:VIEW",
  Add = "Billing:AccountsReceivable:Adjustment:ADD",
  Delete = "Billing:AccountsReceivable:Adjustment:DELETE",
}

export enum AccountsReceivableWriteOffApproval {
  View = "Billing:AccountsReceivable:WriteOffApproval:VIEW",
  Edit = "Billing:AccountsReceivable:WriteOffApproval:EDIT",
}

// CO-3390 Feature 1 (PRD REQ-004) — opening the Room and Board month-end-close dashboard.
//
// The literal is a CONTRACT with the API and is stated in exactly three places: here, the
// Go constant in domains/billing/libraries/iam-permissions/billing_permissions.go, and the
// catalog row in
// domains/platform/libraries/user-permissions/scripts/data/Permissions.json. The Go side's
// comment claimed two places and this file was the missing one, so the string existed only
// in Go, no catalog row was ever created, and iam answered `false` for every account —
// which is a permission that refuses everyone and looks exactly like one that grants
// everyone until somebody gates on it.
//
// DEPLOYMENT ORDER MATTERS. The catalog row makes the permission askable; it does not grant
// it. Until an administrator grants it to the billing and finance roles, this ask answers
// false and the R&B tab does not render. Grant first, then ship the gate.
export enum MonthEndCloseRoomAndBoard {
  View = "Billing:MonthEndClose:RoomAndBoard:VIEW",
}



// WEBPACK FOOTER //
// ./src/app/access-control/permissions.ts